<div class="strategy-edition">
  <div class="strategy-edition__container">
    <div class="left-bar">
      <img src="images/atm-logo-positive-gbm.svg" />
      <div class="left-bar__container">
        <div class="branding__logo mark mark__trading mark--animated">
          <div class="full-circle">
            <div class="half--right">
              <div class="fill"></div>
            </div>
            <div class="half--left">
              <div class="fill"></div>
            </div>
          </div>
          <div class="half-circle">
            <div class="half">
              <div class="fill"></div>
            </div>
          </div>
        </div>
        <div class="left-bar__title">Edita el nombre de tu estrategia</div>
        <div class="left-bar__input">
          <input
            #inputTmpl
            type="text"
            class="input__input input__input--big"
            maxlength="20"
            [ngClass]="{ 'input--error': !isUniqueName || !isValidName }"
            (input)="onInput(inputTmpl)"
            [(ngModel)]="strategyName"
          />
          <span class="input__counter"
            >{{ strategyName?.length || '0' }}/20</span
          >
          <p class="input__error-label" *ngIf="!isUniqueName">
            Ya existe una estrategia con este nombre
          </p>
          <p class="input__error-label" *ngIf="!isValidName">
            El nombre de la estrategia no es válido
          </p>
        </div>
        <div class="left-bar__actions">
          <button
            *ngIf="!loading"
            type="submit"
            (click)="confirmationAction()"
            class="button button--small button--dark"
            [class.button--disabled]="isInvalid"
            [disabled]="isInvalid"
          >
            Guardar cambios
          </button>
          <button
            *ngIf="loading"
            class="button button--small button--dark button--loading button--disabled"
            disabled
          >
            <div class="button__loader">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="rigth-bar">
      <img src="images/icons/atm-cta-close.svg" (click)="hide()" />
    </div>
  </div>
</div>
